import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: -webkit-fill-available;
  gap: 5px;
  font-family: 'Montserrat', sans-serif;
  margin-top: 16px;
  justify-items: start;
  align-items: start;
`;

export const Header = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #003049;
  text-align: start;
  margin-bottom: 8px;
`;

export const Row = styled.div`
  display: grid;
  align-items: start;
  margin-bottom: 8px;
  width: -webkit-fill-available;
  flex-direction: row;
  justify-content: start;
  grid-template-columns: 35% 40% 20%;
  
`;

export const Data = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
`;

export const ObservationsText = styled.p`
  margin: 0;
  overflow: hidden;
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  word-wrap: break-word;
`;